import {defaultContacts} from "./state";

export function settypes_operations(state,types_operations){
    state.types_operations = types_operations
}

export function setDateSusbs(state, date_subs){
    state.date_subs = date_subs
}

export function setloading_(state, loading_){
    state.loading_ = loading_
}


// WEBPACK FOOTER //
// ./src/modules/clear-erp/mutations.js